import { FC, MouseEventHandler } from "react";
import { AddCircle, AutoFixHigh } from "@mui/icons-material";
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { useAtom, useSetAtom } from "jotai";
import IwButton from "../../components/app/IwButton";
import TemplateEditorModal from "../../components/discovery/template/TemplateEditorModal";
import { baseAtom, setViewTemplatesOpen } from "../../stores/jotai/base";
import {
  setSelectedTemplate,
  templatesAtom
} from "../../stores/jotai/template/templates";
import BGStep2 from "./icon/BGStep2";
import { StepperCountBox } from "./common/StepperCountBox";

interface IEmptySegmentCardProps {
  segmentName: "canvas" | "interview" | "template" | "insight";
  generateTemplate: () => void;
}

const EmptySegmentCard: FC<IEmptySegmentCardProps> = (props) => {
  const { generateTemplate } = props;
  const [base, setBase] = useAtom(baseAtom);
  const setTemplateAtomState = useSetAtom(templatesAtom);
  return (
    <>
      <TemplateEditorModal
        open={base.viewTemplatesOpen}
        handleDialogClose={() => {
          setViewTemplatesOpen(setBase, false);
          setSelectedTemplate(setTemplateAtomState, null);
        }}
      />
      <Box
        sx={{
          height: "100%",
          p: 2,
          backgroundColor: "white",
          opacity: 0.9,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxShadow:
            "0 0 0 0.67px rgba(0, 0, 0, 0.09), 0 34px 20px rgba(0, 0, 0, 0.024)"
        }}
      >
        <Stack direction="column" alignItems="center" spacing={2}>
          <StepperCountBox
            stepperCount={2}
            text="Create your Interview Template"
          />

          <BGStep2 width={"260px"} height={"inherit"} />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1
            }}
          >
            <Typography
              variant="h6"
              component="div"
              textAlign="center"
              fontSize="16px"
            >
              Know what questions to ask.
            </Typography>
            <Typography variant="body2" textAlign="center" fontSize="15px">
              {
                base.team?.isAiInterviewTemplateGenerationEnabled ? "Generate tailored interview questions for each customer segment.":"Note down interview questions for each customer segment to use during customer discovery sessions."
              }
            </Typography>
          </Box>
          <Stack direction="row" alignItems="center" spacing={2}>
            <IwButton
              variant="outlined"
              disabled={!base?.roleSnapshot?.isTeamMember}
              startIcon={<AddCircle width={24} />}
              size="large"
              onClick={() => {
                setViewTemplatesOpen(setBase, true);
              }}
            >
              Create manually
            </IwButton>
            {base.team?.isAiInterviewTemplateGenerationEnabled ? (
          
            <Box sx={{ marginLeft: "auto" ,display: 'inline-block'}}>
            <IwButton
              variant="contained"
              startIcon={<AutoFixHigh />}
              size="large"
              onClick={generateTemplate}
            >
              Generate with AI
            </IwButton>
            </Box>
          ): null}
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default EmptySegmentCard;
